module.exports = __webpack_public_path__ + "images/icon/close_circle_16-a65e2734.svg";